import { IconButton, Stack, alpha, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as IISLogo } from "assets/IISLogo.svg";
import LeftPanel from "./LeftPanel";
import { MenuItem } from "./types";

interface MobileMenuProps {
  isOpen: boolean;
  menuItems: MenuItem[];
  activeMenuItem: number;
  onMenuItemClick: (index: number) => void;
  onClose: () => void;
}

export default function MobileMenu({
  isOpen,
  menuItems,
  activeMenuItem,
  onMenuItemClick,
  onClose,
}: MobileMenuProps) {
  const theme = useTheme();

  if (!isOpen) return null;

  return (
    <Stack
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
      onClick={onClose}
    >
      <Stack
        sx={{
          width: "400px",
          height: "100%",
          backgroundColor: "background.paper",
          borderRight: "1px solid",
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
          boxShadow: `2px 0 8px ${alpha(theme.palette.common.black, 0.15)}`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header with Logo and Close Button */}
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            px: 2,
            py: 1.5,
            minHeight: "64px",
          }}
        >
          <IISLogo style={{ height: "40px", width: "auto" }} />
          <IconButton
            onClick={onClose}
            sx={{
              width: "40px",
              height: "40px",
              p: 1,
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <CloseIcon
              sx={{
                width: "20px",
                height: "20px",
                color: "action.active",
              }}
            />
          </IconButton>
        </Stack>

        {/* Modal Content */}
        <Stack sx={{ px: 3, pb: 3 }}>
          <LeftPanel
            menuItems={menuItems}
            activeMenuItem={activeMenuItem}
            onMenuItemClick={onMenuItemClick}
            isSmallScreen={true}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
